import { Injectable, signal } from '@angular/core';
import { UserProfile } from '../../models/auth.model';
@Injectable({
  providedIn: 'root'
})
export class StateService {
  public isMobileSignal = signal<boolean>(false);
  public isLoggedIn = signal<boolean>(false);
  public vetsCount = signal<number>(0);
  public profile = signal<UserProfile | null>(null);

  public isWebView = signal<boolean>(false);
}
